import COLORS from './colors';

const lynqAiDailyQueriesChartConfig = {
  name: 'lynq_ai_daily_queries',
  title: 'Daily question volume',
  metric: 'lynq_ai_daily_queries',
  helpText: 'metrics_tab.smart_assist_tab.overview_tab.daily_queries.help_text',
  maxTickLabelCount: 8,
  lines: {
    answered: {
      label: 'Answered',
      position: 1,
      color: COLORS.green,
    },
    unanswered: {
      label: 'Unanswered',
      position: 2,
      color: COLORS.red,
    },
  },
};

export default lynqAiDailyQueriesChartConfig;
